import { sendToShell, isInShell } from './messaging';

export function navigateToApp(appId: string, params?: Record<string, string>): void {
  if (!isInShell()) {
    console.warn('navigateToApp called outside shell — no-op');
    return;
  }
  sendToShell({ type: 'app:navigate-to', appId, params });
}

export function backToLauncher(): void {
  if (!isInShell()) return;
  sendToShell({ type: 'app:back-to-launcher' });
}

export function setShellTitle(title: string): void {
  if (!isInShell()) return;
  sendToShell({ type: 'app:set-title', title });
}

export function notifyShell(level: 'info' | 'success' | 'error', text: string): void {
  if (!isInShell()) return;
  sendToShell({ type: 'app:notify', level, text });
}

export function reportPendingCount(appId: string, pendingCount: number): void {
  if (!isInShell()) return;
  sendToShell({ type: 'app:stat-update', appId, pendingCount });
}
